import React, { useState, useMemo } from 'react'

import { PageHeader } from 'components/PageHeader'
import { ConfigUtils } from 'utils/config'

import { Memberships } from '../Memberships'
import { Coupons } from '../Coupons'
import { Benefits } from './Benefits'
import { Preview } from './Preview'

const { modules } = ConfigUtils
const isPromosModuleEnabled = modules.promos.enabled

const ALL_TABS = [
  { key: 'niveles', label: 'Niveles' },
  { key: 'beneficios', label: 'Gestor de beneficios' },
  { key: 'cupones', label: 'Cupones' },
  { key: 'preview', label: 'Preview por nivel' },
]

const Loyalty: React.FC = () => {
  const [activeTab, setActiveTab] = useState('niveles')

  // Filtrar tabs según módulos activos
  const tabs = useMemo(() => {
    return ALL_TABS.filter(tab => {
      if (tab.key === 'cupones' && !isPromosModuleEnabled) {
        return false
      }
      return true
    })
  }, [])

  // Si el tab activo fue ocultado, cambiar al primer tab disponible
  React.useEffect(() => {
    if (!tabs.find(tab => tab.key === activeTab)) {
      setActiveTab(tabs[0]?.key || 'niveles')
    }
  }, [tabs, activeTab])

  const handleTabChange = (tabKey: string) => {
    setActiveTab(tabKey)
  }

  const renderContent = () => {
    switch (activeTab) {
      case 'niveles':
        return <Memberships />
      case 'beneficios':
        return <Benefits />
      case 'cupones':
        if (!isPromosModuleEnabled) {
          return null
        }
        return <Coupons />
      case 'preview':
        return <Preview />
      default:
        return null
    }
  }

  return (
    <div>
      <PageHeader title="Loyalty" tabs={tabs} activeTab={activeTab} onTabChange={handleTabChange} />
      {renderContent()}
    </div>
  )
}

export { Loyalty }
